import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

interface User {
  id: number;
  username: string;
  firstName: string;
  lastName?: string;
  email: string;
  contact: string;
  address: string;
  roleId?: number | null;
  role?: string | null;
  hasProfilePicture?: boolean;
}

interface AuthState {
  user: User | null;
  status: "idle" | "loading" | "succeeded" | "failed";
}

export const fetchCurrentUser = createAsyncThunk(
  "auth/fetchCurrentUser",
  async (_, { rejectWithValue }) => {
    const response = await fetch("/api/auth/me", { credentials: "include" });
    if (!response.ok) return rejectWithValue("Not authenticated");
    return response.json() as Promise<User>;
  }
);

export const logoutUser = createAsyncThunk("auth/logoutUser", async () => {
  await fetch("/api/auth/logout", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });
});

const authSlice = createSlice({
  name: "auth",
  initialState: { user: null, status: "idle" } as AuthState,
  reducers: {
    clearUser(state) {
      state.user = null;
      state.status = "idle";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCurrentUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
      })
      .addCase(fetchCurrentUser.rejected, (state) => {
        state.status = "failed";
        state.user = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.status = "idle";
      });
  },
});

export const { clearUser } = authSlice.actions;
export default authSlice.reducer;
